// extracted by mini-css-extract-plugin
export default {"Parent":"MfaInput_Parent__Fz6gs","Digit":"MfaInput_Digit__MUj3f"};